import React, { useState, useEffect } from 'react';
import { invalidYouTubeURL } from "../../../constants/errorMessages";

function VideoUploadSection(props) {
  const [videoLinkText, setVideoLinkText] = useState('');
  const { allowVideo, uploadedMedia, hasUploadedVideo, wrapperClasses, setMediaType, hasYouTubeError } = props;

  useEffect(() => {
    // If a video link has already been uploaded, display the link
    if (hasUploadedVideo) {
      setVideoLinkText(uploadedMedia[0].url);
    }
  }, [hasUploadedVideo, uploadedMedia]);

  function handleUserInput(input) {
    setVideoLinkText(input);
  }

  return (
    <div className={wrapperClasses}>
      <div className="ugc-contribution-modal--youtube-conatiner">
        <label className="ugc-contribution-modal--youtube-conatiner-label" htmlFor="videoLink">
          {hasUploadedVideo ? 'Edit' : 'Add'} your link to a YouTube video below
        </label>

        {
          hasYouTubeError &&
          <div className="ugc-contribution-modal--youtube-link-error">
            {invalidYouTubeURL}
          </div>
        }

        <input
          className={`ugc-contribution-modal--textarea form-control ${hasYouTubeError ? 'border-error ugc-contribution-modal--textarea-error' : 'ugc-contribution-modal--textarea-video-default'}`}
          name="YouTubeUrl"
          type="text"
          onChange={(e) => handleUserInput(e.target.value)}
          placeholder="Paste your link here..."
          value={videoLinkText}
          disabled={!allowVideo}
        />
      </div>
      <button
        className="govuk-button he-button he-button__neutral"
        onClick={() => setMediaType('none')}>
        Remove
      </button>
    </div>
  );
}

export default VideoUploadSection;
